import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  converDateIntoLocal,
  converDateIntoLocalWithOutFormat,
  screenHeightLeftFromTop,
} from "Constants";
/*** Import Actions ***/
import { updateUnsavedChanges } from "DashboardMenuAction";
import { fetchSupportChat, fetchUserDetailsWithEmail } from "SupportChatAction";
import { fetchBranding, fetchBrandingEmpty } from "BrandingAction";
import { fetchTemplate } from "SettingActions";
import SupportChatView from "SupportChatView";
import Loader from "Loader";
import LocaleStrings from "Languages";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Supportchat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.content_text_plotting_chat,
      selectedUserEmail: "",
    };

    this.processQueue = false;
    this.intervalUserList = null;
  }

  componentDidMount() {
    /*** Fetch Email Template ***/
    this.props.updateUnsavedChanges(false);
    this.props.fetchTemplate(this.props.session);

    /*** Thread List (DISTINCT USER) ***/
    this.props.fetchSupportChat(this.props.session, (callback) => {
      this.setState({ loading: false });
    });

    this.props.fetchBranding(this.props.session);

    this.interval = setInterval(() => {
      this.props.fetchSupportChat(this.props.session, (callback) => {});
    }, 10000);
  }

  componentWillUnmount() {
    this.setState({ loading: true });
    this.setState({ selectedUserEmail: "" });
    clearInterval(this.interval);
  }

  textToNameInit(value, separator) {
    // Ex - xx.yy@g.com -> XG
    let textToReturn = "";
    if (value && separator) {
      textToReturn = _.replace(
        _.upperCase(
          _.split(value, separator, 2)[0][0] +
            _.split(value, separator, 2)[1][0]
        ),
        " ",
        ""
      );
    }
    return textToReturn;
  }

  /* Open Thread Details */
  openChatDetails(value) {
    /*** Note :- Get User Details If Event Id and Email Id Is Exists Under AppUser Table ***/
    this.props.fetchUserDetailsWithEmail(
      this.props.session,
      value.useremail,
      (callback) => {}
    );
    this.setState({ selectedUserEmail: _.trim(value.useremail) });
  }

  showtime(senton) {
    var now = moment().format("YYYY-MM-DD");
    var chatdatetime = converDateIntoLocalWithOutFormat(senton);
    var chatdate = moment(chatdatetime).format("YYYY-MM-DD");
    var chattime = moment(chatdatetime).format("HH:mm");
    var a = moment(now);
    var b = moment(chatdate);
    var diffdays = a.diff(b, "days");

    var showtime =
      diffdays == 1
        ? LocaleStrings.yesterday
        : diffdays > 1
        ? moment(b).format("DD/MM/YYYY")
        : chattime;

    return showtime;
  }

  /*** Arrow function for render CHAT THREAD ***/
  renderChatThread() {
    let { selectedUserEmail } = this.state;
    return _.map(this.props.chatThread, (item, index) => {
      let name = this.textToNameInit(item.useremail, "@");
      let email =
        item.useremail !== "" &&
        item.useremail !== null &&
        item.useremail !== "null"
          ? item.useremail.length > 30
            ? item.useremail.substring(1, 30) + "..."
            : item.useremail
          : "";
      return (
        <div
          key={index}
          className={classNames(
            selectedUserEmail === item.useremail
              ? "selected-supportchat-list"
              : "",
            "chat-list-item supportchat-list d-flex"
          )}
          onClick={() => this.openChatDetails(item)}
        >
          <div className="profile-img-col profile-img-col-tab d-flex align-items-center">
            <div
              className="supportchat-user-img align-items-center"
              style={{ position: "relative" }}
            >
              {name}.
              {parseInt(item.unreadcount) > 0 ? (
                <div className="notificatino-icon-text" aria-hidden="true">
                  {item.unreadcount}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="supportchat-user-other-details">
              <div className="d-flex align-items-center profile-img-col-tab">
                <div className="custom-text1-medium supportchat-name">
                  {email}
                </div>
                <div className="custom-text10-normal-secondary supportchat-chattime">
                  {this.showtime(item.senton)}
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="custom-text9-medium-secondary supportchat-message">
                  {item.chattype === "image"
                    ? "📷 Photo"
                    : item.chattype === "file"
                    ? "📁 File"
                    : item.chattype === "video"
                    ? "🎥 Video"
                    : item.message.length > 40
                    ? item.message.substring(0, 40) + "..."
                    : item.message}
                </div>
                <span style={{ paddingTop: 2, color: "black" }}>
                  {item.useragent ? (
                    _.some(["iPhone"], (el) =>
                      _.includes(item.useragent, el)
                    ) ? (
                      ""
                    ) : (
                      // Android svg
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_814_149)">
                          <path
                            d="M6 18C6 18.55 6.45 19 7 19H8V22.5C8 23.33 8.67 24 9.5 24C10.33 24 11 23.33 11 22.5V19H13V22.5C13 23.33 13.67 24 14.5 24C15.33 24 16 23.33 16 22.5V19H17C17.55 19 18 18.55 18 18V8H6V18ZM3.5 8C2.67 8 2 8.67 2 9.5V16.5C2 17.33 2.67 18 3.5 18C4.33 18 5 17.33 5 16.5V9.5C5 8.67 4.33 8 3.5 8ZM20.5 8C19.67 8 19 8.67 19 9.5V16.5C19 17.33 19.67 18 20.5 18C21.33 18 22 17.33 22 16.5V9.5C22 8.67 21.33 8 20.5 8ZM15.53 2.16L16.83 0.86C17.03 0.66 17.03 0.35 16.83 0.15C16.63 -0.05 16.32 -0.05 16.12 0.15L14.64 1.63C13.85 1.23 12.95 1 12 1C11.04 1 10.14 1.23 9.34 1.63L7.85 0.15C7.65 -0.05 7.34 -0.05 7.14 0.15C6.94 0.35 6.94 0.66 7.14 0.86L8.45 2.17C6.97 3.26 6 5.01 6 7H18C18 5.01 17.03 3.25 15.53 2.16ZM10 5H9V4H10V5ZM15 5H14V4H15V5Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_814_149">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )
                  ) : (
                    ""
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    var { deviceSize } = this.props;
    var { selectedUserEmail } = this.state;
    var emptychatconversation_img =
      "../../style/images/support-chat-icons/emptychatconversation.png";

    return (
      <div
        className="outreach-container panel-body"
        style={{ height: deviceSize.height - 72 }}
      >
        {this.state.loading ? (
          <div className="loader-container">
            <Loader />
            <div className="loader-info">{this.state.desc}</div>
          </div>
        ) : _.isEmpty(this.props.chatThread) ? (
          <div className="no-content-message">
            <div>
              <img
                src={emptychatconversation_img}
                alt="empty-chatconversation"
                className="center-img"
              />
              <br />
              <div
                className="nav-bar-subtitle-title"
                align="center"
                style={{ textAlign: "center" }}
              >
                <b>{LocaleStrings.chat_thread_nocontent_header}</b>
              </div>
              <br />
              <div className="no-content-message">
                {LocaleStrings.chat_thread_nocontent_subheader}
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-md-4">
              <div
                className="scrollable-content scrollbar-hide chat-list-container"
                style={{ height: deviceSize.height - 92 }}
              >
                {this.renderChatThread()}
              </div>
            </div>
            <div className="col-md-8">
              {selectedUserEmail !== "" &&
              selectedUserEmail !== null &&
              selectedUserEmail !== "null" ? (
                <SupportChatView
                  history={this.props.history}
                  selectedUserEmail={selectedUserEmail}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  var eventData = {};
  if (state.eventData[0]) {
    eventData = state.eventData[0];
  }

  return {
    settingMenus: state.settingMenus,
    session: state.session,
    eventData,
    deviceSize: state.deviceSize,
    chatThread: !_.isEmpty(state.chatThread) ? state.chatThread : [],
    brandingData: state.brandingData,
  };
}

export default connect(mapStateToProps, {
  fetchSupportChat,
  fetchBranding,
  fetchUserDetailsWithEmail,
  fetchTemplate,
  updateUnsavedChanges,
})(Supportchat);
